import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Select } from "antd";
import { getData } from "../../../../utils/api";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);

  const [formData, setFormData] = useState({
    name: "",
    contact_no: "",
    email: "",
    gst_no: "",
    start_month: "",
    end_month: "",
    kyc_document: "",
    aadhar_no: "",
    pan_no: "",
    address: "",
    company_name: "",
  });
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [product, setProduct] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const KYC_Document = [
    { value: "aadhar", name: "aadhar", label: "Aadhar" },
    { value: "pan", name: "pan", label: "Pan" },
  ];

  const handleChange = (nameOrEvent, value) => {
    // If called from a normal input
    if (nameOrEvent?.target) {
      const e = nameOrEvent;
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
    // If called from React-Select
    else {
      setFormData({
        ...formData,
        [nameOrEvent]: value,
      });
    }
  };

  const handleProductChange = (selectedOptions) => {
    setFormData({
      ...formData,
      product_id: selectedOptions,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const validationErrors = await Validation.FormValidation({
      classname: ".initialclass",
    });

    if (!formData.kyc_document) {
      return; // stop submit, error will now show
    }

    if (!formData.product_id) {
      alert("Select Atleast 1 product");
    }

    if (validationErrors) {
      try {
        const response = await postData("/masters/customer", formData);
        setShowModal({ code: response.code, message: response.message });

        setTimeout(() => {
          setShowModal(0);
          props.handleClose();
          setIsSubmitted(false); // reset for next open
        }, 1000);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const handleKeyPressContact = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    if (!/^\d*\.?\d*$/.test(keyValue)) {
      event.preventDefault();
    }
  };

  const GetAllProduct = async () => {
    const response = await getData("/masters/allproducts-list");

    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "product_id",
          label: data.name,
        });
      });
    }
    setProduct(option);
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}>
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Add Country</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded ">
            <Card.Body>
              <Card.Title>Add Customer</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className="initialclass">
                            <Row>
                              <Col
                                lg={8}
                                md={10}
                                className=" mx-auto Add-content">
                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Name
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                placeholder="Name "
                                                id="inputEmail3"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Company Name
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="company_name"
                                                value={formData.company_name}
                                                onChange={handleChange}
                                                placeholder="Company Name "
                                                id="inputEmail3"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Contact Number
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="contact_no"
                                                value={formData.contact_no}
                                                onChange={(e) => {
                                                  const value = e.target.value;

                                                  // Allow only numbers and limit to 10 digits
                                                  if (
                                                    /^\d{0,10}$/.test(value)
                                                  ) {
                                                    handleChange(e);
                                                  }
                                                }}
                                                maxLength={10} // UI-level limit
                                                placeholder="Contact Number"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Email
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                placeholder="Email "
                                                id="inputEmail3"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          GST No
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="gst_no"
                                                value={formData.gst_no}
                                                onChange={handleChange}
                                                placeholder="GST No "
                                                id="inputEmail3"
                                              />
                                            </InputGroup>
                                            {/* <span className="error-message"></span> */}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Address
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="tel"
                                                name="address"
                                                value={formData.address}
                                                onChange={handleChange}
                                                placeholder="Address "
                                                id="inputEmail3"
                                              />
                                            </InputGroup>
                                            {/* <span className="error-message"></span> */}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Start Month
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="date"
                                                name="start_month"
                                                value={formData.start_month}
                                                onChange={(e) => {
                                                  const value = e.target.value;

                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    start_month: value,
                                                    // end_month: "",
                                                  }));
                                                }}
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          End Month
                                        </Form.Label>

                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="date"
                                                name="end_month"
                                                value={formData.end_month || ""}
                                                min={
                                                  formData.start_month ||
                                                  new Date()
                                                    .toISOString()
                                                    .split("T")[0]
                                                }
                                                onChange={(e) => {
                                                  const value = e.target.value;

                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    end_month: value,
                                                  }));
                                                }}
                                                className="input-mandatory"
                                              />
                                            </InputGroup>

                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Select Product
                                        </Form.Label>

                                        <Col sm={6}>
                                          <Select
                                            mode="multiple"
                                            name="product_id"
                                            className="input-mandatory"
                                            value={product.filter((p) =>
                                              formData.product_id?.includes(
                                                p.value,
                                              ),
                                            )}
                                            onChange={handleProductChange}
                                            options={product}
                                          />

                                          <span className="error-message"></span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Select KYC Document{" "}
                                          <span className="text-danger">*</span>
                                        </Form.Label>

                                        <Col sm={6}>
                                          <Select
                                            name="kyc_document"
                                            classNamePrefix="react-select"
                                            className={
                                              isSubmitted &&
                                              !formData.kyc_document
                                                ? "is-invalid"
                                                : ""
                                            }
                                            options={KYC_Document}
                                            value={formData.kyc_document}
                                            onChange={(value) =>
                                              handleChange(
                                                "kyc_document",
                                                value,
                                              )
                                            }
                                            placeholder="Select KYC Document"
                                          />

                                          {isSubmitted &&
                                            !formData.kyc_document && (
                                              <span className="text-danger">
                                                KYC document is required
                                              </span>
                                            )}
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  {formData.kyc_document === "aadhar" && (
                                    <Col md={12}>
                                      <div className="main-form-section mt-5">
                                        <Row className="justify-content-center">
                                          <Form.Label column sm={3}>
                                            Aadhar No
                                          </Form.Label>
                                          <Col sm={6}>
                                            <Form.Group>
                                              <InputGroup>
                                                <Form.Control
                                                  type="text"
                                                  name="aadhar_no"
                                                  value={
                                                    formData.aadhar_no || ""
                                                  }
                                                  onChange={(e) => {
                                                    let v = e.target.value;
                                                    if (/^\d{0,12}$/.test(v))
                                                      handleChange(e); // only 12 digits allowed
                                                  }}
                                                  maxLength={12}
                                                  placeholder="Enter Aadhar Number"
                                                  className="input-mandatory"
                                                />
                                              </InputGroup>
                                              <span className="error-message"></span>
                                            </Form.Group>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Col>
                                  )}

                                  {/* --- PAN No (Show only if Pan selected) --- */}
                                  {formData.kyc_document === "pan" && (
                                    <Col md={12}>
                                      <div className="main-form-section mt-5">
                                        <Row className="justify-content-center">
                                          <Form.Label column sm={3}>
                                            Pan No
                                          </Form.Label>
                                          <Col sm={6}>
                                            <Form.Group>
                                              <InputGroup>
                                                <Form.Control
                                                  type="text"
                                                  name="pan_no"
                                                  value={formData.pan_no || ""}
                                                  onChange={(e) => {
                                                    let v =
                                                      e.target.value.toUpperCase();
                                                    if (
                                                      /^[A-Z0-9]{0,10}$/.test(v)
                                                    )
                                                      handleChange({
                                                        target: {
                                                          name: "pan_no",
                                                          value: v,
                                                        },
                                                      });
                                                  }}
                                                  maxLength={10}
                                                  placeholder="Enter PAN Number"
                                                  className="input-mandatory"
                                                />
                                              </InputGroup>
                                              <span className="error-message"></span>
                                            </Form.Group>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Col>
                                  )}
                                </Row>

                                <Row className="mt-5 pb-3">
                                  <div className="d-flex justify-content-center">
                                    <Link>
                                      <CancelButton
                                        name={"cancel"}
                                        handleClose={props.handleClose}
                                      />
                                    </Link>
                                    <SaveButton
                                      name={"save"}
                                      handleSubmit={handleSubmit}
                                    />
                                  </div>
                                </Row>
                              </Col>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
